<template>
    <div :class="className + ' form-check two gcg10'">
        <input class="" type="checkbox" :id="id" :value="id" @change="$emit('input', $event.target.checked)" />
        <label class="form-check-label" :for="id">{{ label }}</label>
    </div>
</template>

<script>
    export default {
        name: "Checkbox",
        props: {
            label: String,
            id: String,
            className: '',
            validate: true
        },
        data: () => ({
            volunteer: {
                first_name: '',
                last_name: '',
                date_of_birth: '',
                home_number: '',
                email: '',
                cell_number: '',
                address: '',
                hours: [],
                services: [],

            }
        })
    }
</script>

<style scoped>

</style>
